// DS: I32B
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CloseBig: React.FC<Props> = props => {
  const uniqueId = useUniqueId();
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="0"
        height="0"
        viewBox="0 0 24 24"
      >
        <defs>
          <path
            id={`i32-b-${uniqueId}`}
            d="M13.765 12L22 20.235 20.235 22 12 13.765 3.765 22 2 20.235 10.235 12 2 3.765 3.765 2 12 10.235 20.235 2 22 3.765 13.765 12z"
          />
        </defs>
        <g fillRule="evenodd">
          <use fill="currentColor" xlinkHref={`#i32-b-${uniqueId}`} />
        </g>
      </svg>
    </IconWrap>
  );
};
CloseBig.displayName = 'CloseBig';

export default CloseBig;
